import React, { useState } from 'react';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Feedback.css';
const Feedback = ({ value, onFeedback }) => {
    const [feedback, setFeedback] = useState(value);
    const handleThumbClick = (type) => {
        setFeedback(type);
        onFeedback(type);
    };
    return (React.createElement("div", { className: "feedback-container" },
        React.createElement("div", { className: `thumb thumb-up ${feedback === 10 ? 'active' : ''}`, onClick: () => {
                return feedback === 10 ? handleThumbClick(null) : handleThumbClick(10);
            }, onKeyDown: () => { }, role: "button", tabIndex: 0 },
            React.createElement(FontAwesomeIcon, { icon: faThumbsUp })),
        React.createElement("div", { className: `thumb thumb-down ${feedback === 0 ? 'active' : ''}`, onClick: () => {
                return feedback === 0 ? handleThumbClick(null) : handleThumbClick(0);
            }, onKeyDown: () => { }, role: "button", tabIndex: 0 },
            React.createElement(FontAwesomeIcon, { icon: faThumbsDown }))));
};
export default Feedback;
